/**
 *  @class
 *  @function EventCountdownTimer
 */
if (!customElements.get('event-countdown-timer')) {
  class EventCountdownTimer extends HTMLElement {
    constructor() {
      super();

      let time = this.dataset.time,
        tarhour = 0,
        tarmin = 0;

      if (time) {
        [tarhour, tarmin] = time.split(':').map(Number);
      }

      this.tarhour = tarhour;
      this.tarmin = tarmin;
      this.offsetMinutes = EventCountdownTimer.parseUtcOffset(this.dataset.utcOffset);
      this.designMode = this.dataset.designMode === 'true';
      this.sectionEl = this.closest('.section-event-countdown-banner');
      this.countDownDate = this._nextOccurrence();
    }

    static parseUtcOffset(offset) {
      const match = String(offset || '').match(/^([+-])(\d{2})(\d{2})$/);
      if (!match) return 0;
      const sign = match[1] === '-' ? -1 : 1;
      return sign * (Number(match[2]) * 60 + Number(match[3]));
    }

    _shopDate(date) {
      return new Date(date.getTime() + this.offsetMinutes * 60 * 1000);
    }

    _shopWallClockToUtc(year, month, day, hour, minute) {
      return Date.UTC(year, month, day, hour, minute, 0, 0) - this.offsetMinutes * 60 * 1000;
    }

    _nextOccurrence() {
      const shopNow = this._shopDate(new Date());
      const year = shopNow.getUTCFullYear();
      const month = shopNow.getUTCMonth();
      const day = shopNow.getUTCDate();
      let targetUtc = this._shopWallClockToUtc(year, month, day, this.tarhour, this.tarmin);

      if (targetUtc <= Date.now()) {
        const nextDay = this._shopDate(new Date(targetUtc + 24 * 60 * 60 * 1000));
        targetUtc = this._shopWallClockToUtc(
          nextDay.getUTCFullYear(),
          nextDay.getUTCMonth(),
          nextDay.getUTCDate(),
          this.tarhour,
          this.tarmin
        );
      }

      return targetUtc;
    }

    _hideSection() {
      if (this.designMode || !this.sectionEl) return;
      this.sectionEl.setAttribute('hidden', '');
      this._updateStickyOffset();
    }

    _placeSection() {
      const section = this.sectionEl;
      if (!section || section.dataset.eventPlaced === 'true') return;
      section.dataset.eventPlaced = 'true';

      if (this.dataset.stickyTop === 'true') {
        section.classList.add('event-countdown-banner--sticky');
      }

      const className = (this.dataset.insertAbove || '').trim();
      if (/^[A-Za-z_-][A-Za-z0-9_-]*$/.test(className)) {
        const target = document.querySelector('.' + CSS.escape(className));
        if (target && !section.contains(target) && !target.contains(section)) {
          target.parentNode.insertBefore(section, target);
        }
      }

      if (this.dataset.stickyTop === 'true') {
        this._bindStickyOffset();
      }
    }

    _bindStickyOffset() {
      const header = document.querySelector('.header-section, .custom-header-section');
      this._beforeHeader = !!(header && (this.sectionEl.compareDocumentPosition(header) & Node.DOCUMENT_POSITION_FOLLOWING));
      this._onResize = () => this._updateStickyOffset();
      window.addEventListener('resize', this._onResize);
      if (window.ResizeObserver) {
        this._resizeObserver = new ResizeObserver(() => this._updateStickyOffset());
        this._resizeObserver.observe(this.sectionEl);
      }
      this._updateStickyOffset();
    }

    _updateStickyOffset() {
      if (this.dataset.stickyTop !== 'true') return;
      const height = this._beforeHeader && !this.sectionEl.hasAttribute('hidden') ? this.sectionEl.offsetHeight : 0;
      document.documentElement.style.setProperty('--event-countdown-sticky-offset', height + 'px');
    }

    disconnectedCallback() {
      if (this._onResize) window.removeEventListener('resize', this._onResize);
      if (this._resizeObserver) this._resizeObserver.disconnect();
    }

    connectedCallback() {
      const alreadyPlaced = this.sectionEl && this.sectionEl.dataset.eventPlaced === 'true';
      this._placeSection();
      if (alreadyPlaced || this.dataset.timerReady === 'true') return;
      this.dataset.timerReady = 'true';

      const hoursEl = this.querySelector('.hours .event-countdown-timer--column--number'),
        minutesEl = this.querySelector('.minutes .event-countdown-timer--column--number'),
        secondsEl = this.querySelector('.seconds .event-countdown-timer--column--number');

      const updateTime = () => {
        let distance = this.countDownDate - Date.now();

        if (distance <= 0) {
          this.countDownDate = this._nextOccurrence();
          distance = this.countDownDate - Date.now();
          if (this.sectionEl) {
            this.sectionEl.removeAttribute('hidden');
            this._updateStickyOffset();
          }
        }

        const hours = Math.floor(distance / (1000 * 60 * 60)),
          minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60)),
          seconds = Math.floor((distance % (1000 * 60)) / 1000);

        hoursEl.textContent = EventCountdownTimer.addZero(hours);
        minutesEl.textContent = EventCountdownTimer.addZero(minutes);
        secondsEl.textContent = EventCountdownTimer.addZero(seconds);

        requestAnimationFrame(updateTime);
      };

      requestAnimationFrame(updateTime);
    }

    static addZero(x) {
      return (x < 10 && x >= 0) ? '0' + x : x;
    }
  }
  customElements.define('event-countdown-timer', EventCountdownTimer);
}
